export default __webpack_public_path__ + "static/media/banner-img-bkp-4.cdbbaea9.jpg";